import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromClients from './+state/clients.reducer';
import { ClientsEffects } from './+state/clients.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromClients.SHARED_CLIENTS_FEATURE_KEY,
      fromClients.clientsReducer
    ),
    EffectsModule.forFeature([ClientsEffects]),
  ],
})
export class SharedDataAccessClientsModule {}
